import { ShieldCheck } from 'lucide-react';

export function ResourcesDisclaimer() {
  return (
    <div className="border-t border-border py-6 bg-background">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <p className="flex items-center justify-center gap-2 text-xs text-muted-foreground text-center">
          <ShieldCheck className="h-3.5 w-3.5 shrink-0" strokeWidth={1.5} />
          All resources are HIPAA-compliant and peer-reviewed by our Clinical Advisory Board.
        </p>
      </div>
    </div>
  );
}
